module.exports = __webpack_public_path__ + "img/头部背景.fa85d305.png";